import { siteConfig, navLinks } from '@/mocks/siteConfig';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">
                {siteConfig.name}
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {navLinks.slice(0, 5).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {['恋爱漫画', '动作漫画', '奇幻漫画', '悬疑漫画', '搞笑漫画'].map((cat) => (
                <li key={cat}>
                  <a href={`/category/${cat.replace('漫画', '').toLowerCase()}`} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  品牌介绍
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  联系我们
                </a>
              </li>
              <li>
                <a href="mailto:contact@hanmanhua.com" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors" rel="nofollow">
                  {siteConfig.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} {siteConfig.name} 版权所有 | 韩漫在线观看 | 韩国漫画大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}